module.exports = __webpack_public_path__ + "img/light0.40930c8d.png";